import React from "react";

import { RegistrationsProvider } from "../context/registrations_context";
import { AdminGroupPlayerList } from "../components";
import { useParams } from "react-router-dom";

const AdminGroupPlayers = () => {
  const { tournamentId } = useParams();
  const { divisionId } = useParams();
  const { groupId } = useParams();
  return (
    <RegistrationsProvider>
      <AdminGroupPlayerList
        context={{
          tournamentId: tournamentId,
          groupId: groupId,
          divisionId: divisionId,
        }}
      />
    </RegistrationsProvider>
  );
};

export default AdminGroupPlayers;
